module.exports = __webpack_public_path__ + "static/img/3.5a4e663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/culturalCourses/3.png
// module id = ds90
// module chunks = 0